import React from 'react';

const InputWithTooltipPlaceholder = React.forwardRef(({ placeholder, className, style, ...props }, ref) => {
    function isLongPlaceholder(placeholder) {
        return placeholder && placeholder.length > 30;
    }

    return (
        <span style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
            <input
                {...props}
                ref={ref}
                className={className}
                placeholder={placeholder}
                title={isLongPlaceholder(placeholder) ? placeholder : undefined}
                style={isLongPlaceholder(placeholder) ? { ...style, textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', width: '100%' } : { ...style, width: '100%' }}
                onMouseOver={e => {
                    if (isLongPlaceholder(placeholder)) {
                        e.target.setAttribute('data-show-tooltip', 'true');
                    }
                    if (props.onMouseOver) props.onMouseOver(e);
                }}
                onFocus={e => {
                    if (isLongPlaceholder(placeholder)) {
                        e.target.setAttribute('data-show-tooltip', 'true');
                    }
                    if (props.onFocus) props.onFocus(e);
                }}
                onBlur={e => {
                    e.target.removeAttribute('data-show-tooltip');
                    if (props.onBlur) props.onBlur(e);
                }}
            />
            {isLongPlaceholder(placeholder) && (
                <span
                    className="eform-input-tooltip"
                    style={{
                        display: 'none',
                        position: 'absolute',
                        left: 0,
                        top: '100%',
                        background: '#333',
                        color: '#fff',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        whiteSpace: 'normal',
                        zIndex: 10,
                        maxWidth: '300px',
                        fontSize: '12px',
                    }}
                >
                    {placeholder}
                </span>
            )}
            <script dangerouslySetInnerHTML={{
                __html: `
                    document.querySelectorAll('input[data-show-tooltip]')?.forEach(input => {
                        input.addEventListener('mouseover', function() {
                            const tooltip = this.nextElementSibling;
                            if (tooltip) tooltip.style.display = 'block';
                        });
                        input.addEventListener('mouseout', function() {
                            const tooltip = this.nextElementSibling;
                            if (tooltip) tooltip.style.display = 'none';
                        });
                        input.addEventListener('focus', function() {
                            const tooltip = this.nextElementSibling;
                            if (tooltip) tooltip.style.display = 'block';
                        });
                        input.addEventListener('blur', function() {
                            const tooltip = this.nextElementSibling;
                            if (tooltip) tooltip.style.display = 'none';
                        });
                    });
                `
            }} />
        </span>
    );
});

export default InputWithTooltipPlaceholder;
